import $ from 'jquery';
import { MetaRouter } from '../utils/metarouter';

export default ($el) => {
    const $poster = $el.find('.video-banner__poster');
    const $button = $el.find('.video-banner__play');
    const $videoElement = $el.find('video');

    const videoType = $el.data('video-type') || 'mp4';
    const isVimeo = videoType === 'vimeo';
    const vimeoPlayer = isVimeo ? getVimeoPlayer() : undefined;

    $button.on('click', (e) => {
        e.preventDefault();
        $poster.hide();
        $button.hide();

        if (videoType === 'mp4') {
            playMP4();
        } else if (isVimeo) {
            playVimeo();
        }
    });

    function sendPlayEvent() {
        MetaRouter.sendTrackEvent('play_tapped', {
            screen_name: MetaRouter.getPageType(),
        });
    }

    function getVimeoPlayer() {
        const $iframe = $el.find('.video-banner__video iframe');
        return new Vimeo.Player($iframe[0]);
    }

    const playMP4 = () => {
        $el.find('.video-banner__video')[0].play();
    };

    const playVimeo = () => {
        vimeoPlayer?.play();
    };

    if ($videoElement.length > 0) {
        $videoElement.on('play', () => {
            sendPlayEvent();
        });
    }

    if (vimeoPlayer) {
        vimeoPlayer.on('play', () => {
            sendPlayEvent();
        });
    }
};
